<template>
    <Card dis-hover>
        <p slot="title" >{{title}}</p>
        <slot />
    </Card>
</template>

<script>
export default {
    props:{
        title:{type:String,default:"功能页面"},
    },
}
</script>